module.exports = __webpack_public_path__ + "static/media/ul.289d43c3.svg";